import React from 'react';

const IheaderItemsTree = ({ header }: any) => {
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color');

    return (
        <div className="headerItemTree " style={{ display: 'grid', gridTemplateColumns: `repeat(${header.length + 1}, auto)` }}>
            <div style={{ width: '150px', backgroundColor: primaryColor }}>
                <p></p>
            </div>
            {header &&
                header.map((text: string, index: number) => {
                    return (
                        <div style={{ width: '150px', backgroundColor: primaryColor }} key={`${text}--${index}-titles`}>
                            <p>{text != null && text != undefined ? text.toString() : ''}</p>
                        </div>
                    );
                })}
        </div>
    );
};

export default IheaderItemsTree;
